<script lang="ts">
  import type { SwiperOptions } from 'swiper/types';
  import { getAppConfig } from '../../../common/config/app-config';
  import { isMobileWidth } from '../../../common/util';
  import ExtraSwiper from '../../common/components/ExtraSwiper.svelte';
  import Text from '../../common/components/Text.svelte';
  import { getHomeMaintenanceCategoryData } from '../service/home-maintenance-data-services';
  import HMCategoryCard from './HMCategoryCard.svelte';
  import HomeMaintenanceServiceCard from './HomeMaintenanceServiceCard.svelte';
  import { APP_CONSTANTS } from '../../../common/config/app-constants';

  export let metaData;
  let serviceCategories = [];
  let loading = true;
  const isResponsive = isMobileWidth();
  const spaceBetween = isResponsive ? 15 : 25;
  const slidesPerView = 'auto';
  const { homeMaintenanceVipMembershipActive } = getAppConfig();

  export async function onLoad() {
    try {
      window['ACC'].loader.showLoader();
      const data = await getHomeMaintenanceCategoryData(metaData.categories);

      serviceCategories = Array.isArray(data) ? data : [];

      console.log('serviceCategories', serviceCategories);
    } catch (e) {
      console.error(e);
      serviceCategories = [];
    } finally {
      loading = false;
      window['ACC'].loader.hideLoader();
    }
  }

  function getSwiperOptions(slidesPerView, spaceBetween, serviceCount: number): SwiperOptions {
    return {
      navigation: !isResponsive && serviceCount > 2,
      slidesPerView,
      spaceBetween,
    };
  }
</script>

{#if loading}
  <p>Loading...</p>
{:else}
  <section class="home-maintenance-service-category-container-wrapper">
    {#each serviceCategories as category, index}
      <div class="home-maintenance-service-category-container">
        {#if index === 0}
          <div>
            <h2 class={homeMaintenanceVipMembershipActive ? 'vip-user' : 'non-vip-user'}>
              <Text key="extra.home.service.choose.service.text" />
            </h2>
          </div>
        {/if}
        <!-- Level 1 card -->
        <div class="category-card-container">
          <HMCategoryCard
            title={category.title}
            image={`${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}${category?.uid}?fmt=auto&w=${isResponsive ? 220 : 742}&h=${isResponsive ? 196 : 658}&sm=c`}
          />
          <div class="services-row">
            <!-- Level 2 cards -->
            <ExtraSwiper
              slidesData={category.services}
              slideTemplate={HomeMaintenanceServiceCard}
              slideTemplateProps={{ serviceTitle: category?.titleEn }}
              swiperOptions={getSwiperOptions(slidesPerView, spaceBetween, category.services?.length ?? 0)}
            />
          </div>
        </div>
      </div>
    {/each}
  </section>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  h2 {
    font-weight: 500;
    font-size: 30px;
    line-height: 48px;
    @include desktop-max-width {
      margin: 10px 0;
      font-size: 14px;
      line-height: 18px;
    }
    &.vip-user {
      margin: 200px 0 0 0;
    }
    &.non-vip-user {
      margin: 200px 0 0 0;
      @include desktop-max-width {
        margin: 10px 0 0 0;
      }
    }
  }

  .home-maintenance-service-category-container-wrapper {
    display: flex;
    flex-direction: column;
    gap: 18px;
    max-width: 1336px;
    margin: 0 auto;
    @include desktop-max-width {
      gap: 8px;
      padding: 0 3px;
    }
    .home-maintenance-service-category-container {
      display: flex;
      border: 1px solid $secondary-gray-02;
      border-radius: 20px;
      background-color: $neutral-light-04;
      padding: 43px 0 43px 35px;
      gap: 25px;
      flex-direction: column;

      .category-card-container {
        display: flex;
        gap: 25px;
      }
      @include desktop-max-width {
        padding: 15px 8px 15px 8px;
      }
      .services-row {
        display: flex;
        overflow: hidden;
      }
    }
    .home-maintenance-service-category-container:first-child {
      // padding: 190px 0 43px 35px;
      @include desktop-max-width {
        padding: 15px 0 15px 8px;
      }
    }

    :global {
      .swiper-button-next,
      .swiper-button-prev {
        height: 90px !important;
        width: 90px !important;

        &::after {
          font-size: 40px !important;
        }
      }
    }
  }
</style>
